import { render, staticRenderFns } from "./Oled.vue?vue&type=template&id=0c205034&scoped=true"
import script from "./Oled.vue?vue&type=script&lang=js"
export * from "./Oled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c205034",
  null
  
)

export default component.exports